/**
 * Entrar en la agenda de un negocio (spec 016).
 *
 * Un enlace de verdad a `/api/business/:id/agenda/entrar`. El servidor inicia
 * sesión en EA y redirige al calendario ya dentro. La contraseña no pasa por
 * el navegador. Solo administradores (quien monta este botón).
 */
export function AbrirAgenda({ accountId }: { accountId: string }) {
    return (
        <a
            href={`/api/business/${accountId}/agenda/entrar`}
            target="_blank"
            rel="noreferrer"
            title="Abre EasyAppointments ya dentro, en el calendario de este negocio"
            className="inline-flex min-h-11 shrink-0 items-center rounded-md px-2.5 text-sm text-neutral-400 transition hover:bg-neutral-900 hover:text-neutral-200 md:min-h-0"
        >
            Agenda ↗
        </a>
    )
}
